import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB1fo4_0vYSYkgbuOS3q7oBPqpNRMnJMTs",
  authDomain: "vrukshaedu-cb1cf.firebaseapp.com",
  projectId: "vrukshaedu-cb1cf",
  storageBucket: "vrukshaedu-cb1cf.firebasestorage.app",
  messagingSenderId: "632109930030",
  appId: "1:632109930030:web:11dc2032c605f1e3b5b1bf",
  measurementId: "G-3R0D448Z15"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);
// Ensure session persists across reloads
setPersistence(auth, browserLocalPersistence).catch((e) => {
  console.error('Auth persistence setup failed:', e);
});

export const COLLECTIONS = {
  LIVE_TESTS: 'liveTests',
  LIVE_TEST_SESSIONS: 'liveTestSessions',
  LIVE_TEST_PARTICIPANTS: 'liveTestParticipants',
  LIVE_TEST_RESPONSES: 'liveTestResponses',
  ADMIN_USERS: 'adminUsers',
};

export default app;
